import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import Logo from 'components/ui/Logo';
import SubmitButton from 'components/ui/buttons/SubmitButton';
import withSignLayout from 'components/ui/withSignLayout';

import AuthApi from 'api/auth';

class ForgetPasswordPage extends React.Component {
  state = { message: null, recovering: false };

  async onSubmit(e) {
    e.preventDefault();

    this.setState({ recovering: true, message: null });

    const email = document.getElementById('inputEmail').value;
    let message = {};

    try {
      await AuthApi.recovery(email);
      message = { type: 'success', text: 'Enviamos um e-mail com sua nova senha.' };
      this.setState({ message });
    } catch (error) {
      const response = error.response || {};
      const status = response.status || error.status;
      switch (status) {
        case 401:
          message = { type: 'danger', text: 'Usuário não encontrado. Verifique seu e-mail e tente novamente.' };
          break;

        default:
          message = {
            type: 'danger',
            text: 'Falha ao tentar recuperar sua conta. Se o problema persistir, por favor, entre em contato com nosso suporte.',
          };
          break;
      }
    } finally {
      this.setState({ recovering: false, message });
    }
  }

  getMessages() {
    const { message } = this.state;

    if (message) {
      return (
        <div className={`alert alert-${message.type} mt-4`} role="alert">
          {message.text}
        </div>
      );
    }

    return null;
  }

  render() {
    const { t } = this.props;

    return (
      <div className="container d-flex flex-column justify-content-center h-100 align-items-center">
        <div style={{ width: 400 }}>
          <Logo width={150} />
          <p className="mt-4">{t('forget_password.description')}</p>

          <form onSubmit={this.onSubmit.bind(this)}>
            <div className="form-group">
              <input type="email" className="form-control" id="inputEmail" placeholder={t('signin.form.email_input.placeholder')} required />
            </div>

            {this.getMessages()}

            <div className="mt-4 d-flex">
              <SubmitButton loading={this.state.recovering} className="btn btn-primary shadow pl-5 pr-5" tkey="keys.recovery_password" />

              <Link to="/" className="btn btn-outline-primary ms-2">
                {t('keys.back')}
              </Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withSignLayout(ForgetPasswordPage));
